import { render } from "@/components/App.html?vue&type=template&id=2f1b5abc&external"
import script from "@/components/App.js?vue&type=script&lang=js&external"
export * from "@/components/App.js?vue&type=script&lang=js&external"

import "@/components/App.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__